import Dispatcher from 'core/Dispatcher';
import Constants from 'constants.js';
import { sha256 } from 'js-sha256';
import translate from 'locales/i18n';
// Actions
import AlertAction from 'actions/AlertAction';
import LoggedUserAction from 'actions/LoggedUserAction';
// Services
import SignService from 'services/SignService';
// Stores
import LoggedUserStore from 'stores/LoggedUserStore';

class SignAction {

    signIn(email, password) {
        const credentials = {
            login: email,
            password: sha256(password)
        };

        Dispatcher.dispatch({
            actionType: Constants.LOGIN_START
        });

        return SignService.getToken(credentials).then(data => {
            this._onSignIn(data);
        }, err => {
            this._onSignInError();
            throw err;
        });
    }

    logout(forceLogout) {
        localStorage.removeItem('pricecomparator_token');

        if (!forceLogout) {
            Dispatcher.dispatch({
                actionType: Constants.LOGOUT
            });
            AlertAction.open('success', translate.i18n('_DISCONNECTED'), 'top-right');
        }

        if (forceLogout) {
            Dispatcher.dispatch({
                actionType: Constants.LOGOUT
            });
            AlertAction.open('error', translate.i18n('SESSION_EXPIRED'), 'top-right');
        }
    }

    autoLogin() {
        const currentToken = localStorage.getItem('pricecomparator_token');

        if (currentToken === null)
            return null;

        Dispatcher.dispatch({
            actionType: Constants.LOGIN,
            value: {
                email: 'Jean',
                token: currentToken
            }
        });
    }

    _onSignIn(data) {
        localStorage.setItem('pricecomparator_token', data.token);
        LoggedUserAction.initRights();

        Dispatcher.dispatch({
            actionType: Constants.LOGIN,
            value: {
                email: data.email,
                token: data.token
            }
        });

        LoggedUserStore.getCurrent().setToken(data.token);
        AlertAction.open('success', translate.i18n('SIGN_IN_SUCCESS'), 'top-right');
    }

    _onSignInError() {
        AlertAction.open('error', translate.i18n('SIGN_IN_ERROR'), 'top-right');
        Dispatcher.dispatch({
            actionType: Constants.LOGIN_FAILED
        });
    }
}

export default new SignAction();
